import React from 'react'
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Grid } from "@material-ui/core";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { ChatBoxGLPure, GridSelectionHLPure } from '..'
import { useTranslation } from "react-i18next";
import "./panelBarHL-pure.css"
import { newProfileIcon } from '../../../assets/logos/icons';

const PanelBarHLPure = (props) => {

    const { t } = useTranslation();

    let {
        titleItem1,
        titleItem2,
        titleItem3,
        expandedItem1,
        expandedItem2,
        expandedItem3,
        dataItem1,
        setSelectedItem1,
        textTitleItem1,
        textDateLimit,
        styleTextTitleItem1,
        columnTwoItem1,
        columnThreeItem1,
        columnFourItem1,
        columnFiveItem1,
        titleRow1Item1,
        titleRow2Item1,
        titleRow3Item1,
        titleRow4Item1,
        titleRow5Item1,
        headerColumnOneItem1,
        headerColumnTwoItem1,
        headerColumnThreeItem1,
        headerColumnFourItem1,
        cellColumnOneItem1,
        cellColumnTwoItem1,
        cellColumnThreeItem1,
        cellColumnFourItem1,
        iconOneActiveItem1,
        iconTwoActiveItem1,
        iconThirdActiveItem1,
        iconFourthActiveItem1,
        labelOneActionsItem1,
        labelTwoActionsItem1,
        labelThirdActionsItem1,
        labelFourthActionsItem1,
        widthColumnOneItem1,
        widthColumnTwoItem1,
        widthColumnThreeItem1,
        widthColumnFourItem1,
        widthColumnFiveItem1,
        setNameComponentUserItem1,
        setShowDetailsItem1,
        activeDialog1Item1,
        btnOpenDialog1Item1,
        activeDialog2Item1,
        btnOpenDialog2Item1,
        labelBtnDate,
        handleBtnDate,
        dataItem2,
        setSelectedItem2,
        columnTwoItem2,
        columnThreeItem2,
        columnFourItem2,
        columnFiveItem2,
        titleRow1Item2,
        titleRow2Item2,
        titleRow3Item2,
        titleRow4Item2,
        titleRow5Item2,
        headerColumnOneItem2,
        headerColumnTwoItem2,
        headerColumnThreeItem2,
        headerColumnFourItem2,
        cellColumnOneItem2,
        cellColumnTwoItem2,
        cellColumnThreeItem2,
        cellColumnFourItem2,
        iconOneActiveItem2,
        iconTwoActiveItem2,
        iconThirdActiveItem2,
        iconFourthActiveItem2,
        labelOneActionsItem2,
        labelTwoActionsItem2,
        labelThirdActionsItem2,
        labelFourthActionsItem2,
        widthColumnOneItem2,
        widthColumnTwoItem2,
        widthColumnThreeItem2,
        widthColumnFourItem2,
        widthColumnFiveItem2,
        setNameComponentUserItem2,
        setShowDetailsItem2,
        activeDialog1Item2,
        btnOpenDialog1Item2,
        activeDialog2Item2,
        btnOpenDialog2Item2,
        usersChat,
        conversation,
        handleInputChangeChat,
        createMessage,
        membersChat,
        disabledChat,
        userCanEditExpirationDate,
        expirationDate,
        showTextSigns,
        showBarItem2,
        pageableItem1,
        takeItem1,

        pageableItem2,
        takeItem2,
        styleGridItem2,
        styleGeneral1,
        styleGeneralClass1,
        styleGeneral2,
        styleGeneralClass2
    } = props



    return (
        <div className="panelBarHLPure-wrapper">
            <PanelBar>
                <PanelBarItem expanded={expandedItem1} title={titleItem1} className='panelBarHLPure-items-1'>
                    <div className='panelBarHLPure-container-item-1'>
                        <p style={styleTextTitleItem1}>{textTitleItem1}</p>
                        <Grid item className={(pageableItem1 === false && dataItem1.length > 2) ? "panelBarHLPure-gridContainer-scroll" : "panelBarHLPure-gridContainer"}>
                            <GridSelectionHLPure
                                styleGeneral={styleGeneral1}
                                styleGeneralClass={styleGeneralClass1}
                                pageable={pageableItem1}
                                skip={0}
                                take={takeItem1}
                                dataGrid={dataItem1}
                                filter={true}
                                onSelectedItem={setSelectedItem1}
                                setNameComponentUser={setNameComponentUserItem1}
                                setShowDetails={setShowDetailsItem1}
                                cellColumnOne={cellColumnOneItem1}
                                cellColumnTwo={cellColumnTwoItem1}
                                cellColumnThree={cellColumnThreeItem1}
                                cellColumnFour={cellColumnFourItem1}
                                columnTwo={columnTwoItem1}
                                columnThree={columnThreeItem1}
                                columnFour={columnFourItem1}
                                columnFive={columnFiveItem1}
                                disableFirst={disabledChat}
                                titleRow1={titleRow1Item1}
                                titleRow2={titleRow2Item1}
                                titleRow3={titleRow3Item1}
                                titleRow4={titleRow4Item1}
                                titleRow5={titleRow5Item1}
                                headerColumnOne={headerColumnOneItem1}
                                headerColumnTwo={headerColumnTwoItem1}
                                headerColumnThree={headerColumnThreeItem1}
                                headerColumnFour={headerColumnFourItem1}
                                iconOneActive={iconOneActiveItem1}
                                iconTwoActive={iconTwoActiveItem1}
                                iconThirdActive={iconThirdActiveItem1}
                                iconFourthActive={iconFourthActiveItem1}
                                labelOneActions={labelOneActionsItem1}
                                labelTwoActions={labelTwoActionsItem1}
                                labelThirdActions={labelThirdActionsItem1}
                                labelFourthActions={labelFourthActionsItem1}
                                widthColumnOne={widthColumnOneItem1}
                                widthColumnTwo={widthColumnTwoItem1}
                                widthColumnThree={widthColumnThreeItem1}
                                widthColumnFour={widthColumnFourItem1}
                                widthColumnFive={widthColumnFiveItem1}
                                activeDialog1={activeDialog1Item1}
                                btnOpenDialog1={btnOpenDialog1Item1}
                                activeDialog2={activeDialog2Item1}
                                btnOpenDialog2={btnOpenDialog2Item1}
                                styleGrid={{ height: '316px' }}
                            />
                        </Grid>
                        <div className='panelBarHLPure-container-date'>
                            <p className='panelBarHLPure-label-date'>{textDateLimit}</p>
                            <p className='panelBarHLPure-date'>{expirationDate}</p>
                            {
                                userCanEditExpirationDate === true ? (
                                    <div className='panelBarHLPure-btn-edit-date'>
                                        <button
                                            onClick={(e) => handleBtnDate(e)}
                                            className='panelBarHLPure-cellActions-btn'
                                        >
                                            {labelBtnDate}
                                        </button>
                                    </div>
                                )
                                    : null
                            }
                        </div>
                        {showTextSigns ? (
                            <div>
                                <p className="text-processSignature">
                                    {t(
                                        "signatureRequestDetailView2.endProcessSignatures"
                                    )}
                                </p>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </PanelBarItem>
                {
                    showBarItem2 ? (
                        <PanelBarItem expanded={expandedItem2} title={titleItem2} className='panelBarHLPure-items'>
                            <div className='panelBarHLPure-container-item-1'>
                                <Grid item className={(pageableItem2 === false && dataItem2.length > 4) ? "panelBarHLPure-gridContainer-scroll" : "panelBarHLPure-gridContainer"}>
                                    <GridSelectionHLPure
                                        styleGeneral={styleGeneral2}
                                        styleGeneralClass={styleGeneralClass2}
                                        pageable={pageableItem2}
                                        skip={0}
                                        take={takeItem2}
                                        dataGrid={dataItem2}
                                        filter={true}
                                        onSelectedItem={setSelectedItem2}
                                        setNameComponentUser={setNameComponentUserItem2}
                                        setShowDetails={setShowDetailsItem2}
                                        cellColumnOne={cellColumnOneItem2}
                                        cellColumnTwo={cellColumnTwoItem2}
                                        cellColumnThree={cellColumnThreeItem2}
                                        cellColumnFour={cellColumnFourItem2}
                                        columnTwo={columnTwoItem2}
                                        columnThree={columnThreeItem2}
                                        columnFour={columnFourItem2}
                                        columnFive={columnFiveItem2}
                                        titleRow1={titleRow1Item2}
                                        titleRow2={titleRow2Item2}
                                        titleRow3={titleRow3Item2}
                                        titleRow4={titleRow4Item2}
                                        titleRow5={titleRow5Item2}
                                        headerColumnOne={headerColumnOneItem2}
                                        headerColumnTwo={headerColumnTwoItem2}
                                        headerColumnThree={headerColumnThreeItem2}
                                        headerColumnFour={headerColumnFourItem2}
                                        iconOneActive={iconOneActiveItem2}
                                        iconTwoActive={iconTwoActiveItem2}
                                        iconThirdActive={iconThirdActiveItem2}
                                        iconFourthActive={iconFourthActiveItem2}
                                        labelOneActions={labelOneActionsItem2}
                                        labelTwoActions={labelTwoActionsItem2}
                                        labelThirdActions={labelThirdActionsItem2}
                                        labelFourthActions={labelFourthActionsItem2}
                                        widthColumnOne={widthColumnOneItem2}
                                        widthColumnTwo={widthColumnTwoItem2}
                                        widthColumnThree={widthColumnThreeItem2}
                                        widthColumnFour={widthColumnFourItem2}
                                        widthColumnFive={widthColumnFiveItem2}
                                        activeDialog1={activeDialog1Item2}
                                        btnOpenDialog1={btnOpenDialog1Item2}
                                        activeDialog2={activeDialog2Item2}
                                        btnOpenDialog2={btnOpenDialog2Item2}
                                        styleGrid={styleGridItem2}

                                    />
                                </Grid>
                            </div>
                        </PanelBarItem>
                    ) : null
                }
                <PanelBarItem expanded={expandedItem3} title={titleItem3} className='panelBarHLPure-items'>
                    <div className='panelBarHLPure-container-item-3'>
                        <Grid className="followUpActionsContractsView-headerUsersChat">
                            <span className="followUpActionsContractsView-titleGrid">
                                {t("panelBarHLPure.title.chat")}
                            </span>
                            <div className="followUpActionsContractsView-containersAvatars">
                                {membersChat.map((item, index) => (
                                    <div>
                                        <Tooltip
                                            openDelay={600}
                                            position="bottom"
                                            anchorElement="target"
                                            tooltipClassName="tooltipGeneralStyle"
                                        >
                                            <div>
                                                <img
                                                    title={item.name}
                                                    key={index}
                                                    src={
                                                        item.avatarUrl && item.avatarUrl !== ""
                                                            ? item.avatarUrl
                                                            : newProfileIcon
                                                    }
                                                    className="followUpActionsContractsView-avatar"
                                                    alt={item.name}
                                                />
                                            </div>
                                        </Tooltip>
                                    </div>
                                ))}
                            </div>
                        </Grid>
                        <ChatBoxGLPure
                            user={usersChat}
                            conversation={conversation}
                            widthChat={1200}
                            heightChat={300}
                            placeholderChat={t('chatBoxGLPure.placeholder')}
                            handleInputChange={handleInputChangeChat}
                            createMessage={createMessage}
                            disabled={disabledChat}
                        />
                    </div>
                </PanelBarItem>
            </PanelBar>
        </div>
    )
}

export default PanelBarHLPure